import { get } from './http';

export const getBlockData = async (
  blockName: string,
  blockSystemId: string
) => {
  const res = await get(`/api/blocks/${blockName}/${blockSystemId}`);

  if (!res.ok) {
    console.warn(`Could not fetch ${blockName} (${blockSystemId})`);
    console.trace(res, await res.text());
    return undefined;
  }

  return await res.json();
};
